import React, { Component } from 'react'


import { Table, Button, message } from 'antd';

import styles from './style.scss?__local'

import request from 'request'

import PayConfirmModal from './payConfirm'

class UnPayList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataList: [],
      showPayConfirm: false,
      confirmPayInfo: {},
    }

    this.getData = this.getData.bind(this);
    this.closeConfirm = this.closeConfirm.bind(this);
    this.onPaySuccess = this.onPaySuccess.bind(this);
  }

  componentDidMount() {
    this.getData();
  }


  getData() {
    request({
      url: request.api.getUnpayList,
      type: 'GET',
    })
      .done(res => {
        const typeList = res.types;

        const getCurrentType = type => typeList.find(item => item.type == type)

        let dataList = [];

        if (res.serviceBacks) {
          dataList = res.serviceBacks.map((item, idx) => {
            const currentTypeItem = getCurrentType(item.condition.type);

            return Object.assign(item, {
              action: '立即支付',
              feeDetail: `${item.fee / 100}虎牙币（${currentTypeItem.name}为${item.condition.condition}${currentTypeItem.unit})`,
              extName: item.extInfo.name,
              key: idx,
            })
          })
        }

        this.setState({
          dataList,
        })
      })
      .fail(err => {
        message.warn(err);
      })
  }


  pay(record) {
    this.setShowPayConfirm(record);
  }

  onPaySuccess() {
    this.closeConfirm();

    message.info('补缴成功');
    this.getData();
  }

  getTable() {
    const { dataList } = this.state;

    const columnsList = [['未缴费小程序', 'extName'], ['未缴费月份', 'time'], ['未缴费金额', 'feeDetail'], ['操作', 'action']]

    const getColumn = (text, index, record) => {
      if (index < columnsList.length - 1) {
        return <span>{text}</span>
      } else {
        return <Button onClick = {() => {
          this.pay(record)
        }}>{text}</Button>
      }
    }

    const columns = columnsList.map((item, idx) => ({
      title: item[0],
      dataIndex: item[1],
      key: item[1],
      render: (text, record) => getColumn.bind(this, text, idx, record)(),
    }))

    return (
      <Table columns={columns} dataSource={dataList} pagination = {false}></Table>
    )

  }

  setShowPayConfirm(record) {
    const { extName, time, fee, orderId, extInfo } = record;

    this.setState({
      confirmPayInfo: {
        extName,
        time,
        fee,
        orderId,
        extUuid: extInfo.extUuid,
      },
      showPayConfirm: true,
    })
  }

  closeConfirm() {
    this.setState({
      showPayConfirm: false,
    })
  }

  render() {
    const { showPayConfirm, confirmPayInfo } = this.state;

    return (
      <div className={styles.data_wrapper}>
        {
          this.getTable()
        }

        {
          showPayConfirm ?
            <PayConfirmModal info = {confirmPayInfo} closeConfirm = {this.closeConfirm} paySuccess = {this.onPaySuccess}></PayConfirmModal>
            :
            ''
        }
      </div>
    )
  }
}

export default UnPayList;